import pd from './pdReadableFields';

export const createPagerDutyTimeFieldsSource = () => {
  return {
    label: 'Map from PagerDuty',
    loadOptions: async filter => [
      pd.lastChangedAt,
      pd.createdAt
    ],
  };
};

export const createPagerDutyUserFiledSource = () => {
  return {
    label: 'Map from PagerDuty',
    loadOptions: async filter => [
      pd.assignee,
      pd.acknowledgements,
      pd.lastChangedBy
    ],
  };
};

export const createPagerDutyNumberSource = () => {
  return {
    label: 'map from PagerDuty',
    loadOptions: async filter => [
      pd.number
    ],
  };
};

export const createPagerDutyStringSource = () => {
  return {
    label: 'map from PagerDuty',
    loadOptions: async filter => Object.values(pd)
  };
};

